<template>
    <div class="slideshow">
        <VueSlickCarousel
            :centerMode="true"
            :adaptiveHeight="true"
            :infinite="true"
            :autoplay="true"
            :centerPadding="'0'"
            :pauseOnHover="false"
            :arrows="false"
            :autoplaySpeed="autoplayTimeout * 1000">
            <div v-for="(slide, slideIndex) in items" :key="slideIndex" class="slide">
                <img :alt="`slide${slideIndex}`" :src="slide" :style="{'height': `${maxHeight}px`}"/>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
    name: 'SlideshowComponent',
    components: { VueSlickCarousel },
    props: {
        items: Array,
        music: String,
        autoplayTimeout: Number,
        maxHeight: {
            type: Number|null,
            default: null,
            required: false
        },
    },
    data() {
        return {
            audio: null,
        }
    },
    mounted() {
        if (this.music !== null) {
            this.audio = new Audio(this.music);
            this.audio.loop = true;
            this.audio.play();
        }
    },
    beforeDestroy() {
        if (this.music !== null) {
            this.audio.pause();
            this.audio.currentTime = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
    .slideshow {
        .slide {
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                object-fit: cover;
                margin: 0 auto;
                display: block;
            }
        }
    }
</style>
